import React from 'react';
import { GiftIcon, CheckCircle2Icon } from 'lucide-react';
export function ThreeBonus() {
  const includedResources = [{
    title: 'PLANILLA DE CONTROL DE NETO REAL',
    description: 'Tu calculadora personal de riesgo fiscal. Te avisa cuando te acercás al tope.'
  }, {
    title: 'GUÍA ANTI-REQUERIMIENTO AFIP',
    description: 'Protocolo exacto de las primeras 48hs. 3 modelos de nota legal editables incluidos.'
  }, {
    title: 'CHECKLIST DE CONFIGURACIÓN DIGITAL',
    description: '30 acciones para blindar todas tus cuentas y billeteras en una sola tarde.'
  }];
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-[#FAF5EC]" data-id="element-203">
      <div className="max-w-4xl mx-auto" data-id="element-204">
        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12 text-[#1A1A1A]" data-id="element-205">
          🎁 BONUS ESTRATÉGICO — SIEMPRE INCLUIDO
        </h2>

        <div className="bg-white border-2 border-[#F0C040] shadow-md rounded-2xl overflow-hidden" data-id="element-206">
          {/* Card Header */}
          <div className="bg-[#F0C040]/15 p-6 sm:p-8 border-b border-[#F0C040]/30" data-id="element-207">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-208">
              <div className="flex items-center gap-4" data-id="element-209">
                <div className="flex-shrink-0 w-14 h-14 rounded-full bg-[#F0C040] flex items-center justify-center shadow-sm" data-id="element-210">
                  <GiftIcon className="w-7 h-7 text-white" data-id="element-211" />
                </div>
                <div data-id="element-212">
                  <h3 className="text-xl sm:text-2xl font-bold text-[#1A1A1A]" data-id="element-213">
                    Pack de Recursos Extra
                  </h3>
                  <p className="text-sm text-[#6B7280]" data-id="element-214">
                    3 herramientas prácticas incluidas en tu Kit
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0 bg-white px-4 py-2 rounded-full shadow-sm" data-id="element-215">
                <span className="text-sm text-[#6B7280] line-through" data-id="element-216">
                  Valor $25.000
                </span>
                <span className="text-sm font-bold text-[#E8B935]" data-id="element-217">
                  → GRATIS
                </span>
              </div>
            </div>
          </div>

          {/* Resources list */}
          <div className="p-6 sm:p-8 space-y-5" data-id="element-218">
            {includedResources.map((resource, index) => <div key={index} className="flex items-start gap-3" data-id="element-219">
                <CheckCircle2Icon className="w-6 h-6 text-[#5BB4A0] flex-shrink-0 mt-0.5" data-id="element-220" />
                <div data-id="element-221">
                  <h4 className="font-bold text-[#1A1A1A] mb-1" data-id="element-222">
                    {resource.title}
                  </h4>
                  <p className="text-sm text-[#6B7280]" data-id="element-223">
                    {resource.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center mt-8" data-id="element-224">
          <p className="text-xl font-bold" data-id="element-225">
            <span className="text-[#6B7280]" data-id="element-226">Valor total del Bonus: </span>
            <span className="line-through text-[#6B7280]" data-id="element-227">$25.000</span>
            <span className="text-[#E8B935]" data-id="element-228"> → GRATIS con tu Kit</span>
          </p>
        </div>
      </div>
    </section>;
}